import styled from "styled-components";

export const Container = styled.div`
    background: linear-gradient(35.62deg, #BF1827 4.01%, #CC2A55 93.58%);
    padding-bottom: 8rem;
    font-family: 'Poppins', sans-serif;
    color: #3A3B3C;

    .title{
        border-radius: 0.625rem;
        padding: 1rem 1rem 1rem;
        max-width: 50rem;
        margin: auto;
        display: flex;
        flex-direction: column;
        position: relative;
        color: white;

    }
    @media screen and (max-width: 1150px) {
        .title{
            padding-left: 0rem;
            margin: auto;
        }
    }

    @media screen and (max-width: 1150px) {
        padding: 1rem;
    }

`
export const ProfileCard = styled.div`
    border: 1px solid #E2E4E5;
    border-radius: 0.625rem;
    padding: 1rem 3rem 1rem;
    max-width: 45rem;
    margin: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: white;
    

    .client-info {
        
        margin: 2rem 0;

        img{
            border-radius: 50%;
            width: 12.5rem;
            height: 12.5rem;
            object-fit: cover;
        }

        p{
            font-size: 12px;
            color: #AAAAAA;
            margin-bottom: 0;
            
    
        }
    }

    .custom-button{
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none; 
    }

    @media screen and (max-width: 1150px) {
          
    }
`